'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.BulkUpload = void 0;

var _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _officeUiFabricReact = require('office-ui-fabric-react'),
    _TableForm = require('../TableForm'),
    _withHook = require('../FileInputButton/withHook'),
    _ConditionalSpinner = require('../ConditionalSpinner'),
    _ConditionalSpinner2 = _interopRequireDefault(_ConditionalSpinner),
    _ConditionalDataTable = require('../ConditionalDataTable'),
    _ConditionalDataTable2 = _interopRequireDefault(_ConditionalDataTable),
    _ConditionalMessageBar = require('../ConditionalMessageBar'),
    _ConditionalMessageBar2 = _interopRequireDefault(_ConditionalMessageBar);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var tokens = {
  childrenGap: 10
},
    BulkUpload = exports.BulkUpload = function (a) {
  var b = a.goBack,
      c = a.fileInputButton,
      d = a.uploadButton,
      e = a.resetButton,
      f = a.mainSpinner,
      g = a.conditionalDataTable,
      h = a.formRef,
      i = a.editPanel,
      j = a.tableForm,
      k = a.conditionalMessageBar;
  return _react2.default.createElement('form', {
    ref: h
  }, _react2.default.createElement(_officeUiFabricReact.Stack, {
    tokens: tokens
  }, _react2.default.createElement(_officeUiFabricReact.Stack.Item, null, _react2.default.createElement(_officeUiFabricReact.DefaultButton, {
    onClick: b,
    type: 'button',
    text: 'Go Back',
    iconProps: {
      iconName: 'Back'
    }
  })), _react2.default.createElement(_officeUiFabricReact.Stack.Item, null, _react2.default.createElement(_officeUiFabricReact.Stack, {
    horizontal: !0,
    tokens: tokens
  }, _react2.default.createElement(_withHook.FileInputButtonWithHook, c), _react2.default.createElement(_officeUiFabricReact.DefaultButton, d), _react2.default.createElement(_officeUiFabricReact.DefaultButton, e), _react2.default.createElement(_ConditionalSpinner2.default, f), _react2.default.createElement(_ConditionalMessageBar2.default, k))), _react2.default.createElement(_officeUiFabricReact.Stack.Item, null, _react2.default.createElement(_ConditionalDataTable2.default, g)), _react2.default.createElement(_officeUiFabricReact.Stack.Item, null, _react2.default.createElement(_officeUiFabricReact.Panel, i, _react2.default.createElement(_TableForm.TableForm, j)))));
};

BulkUpload.propTypes = {
  goBack: _propTypes2.default.func.isRequired,
  fileInputButton: _propTypes2.default.shape({}).isRequired,
  uploadButton: _propTypes2.default.shape({}).isRequired,
  mainSpinner: _propTypes2.default.shape({}).isRequired,
  resetButton: _propTypes2.default.shape({}).isRequired,
  conditionalDataTable: _propTypes2.default.shape({}).isRequired,
  editPanel: _propTypes2.default.shape({
    isLightDismiss: _propTypes2.default.bool,
    isOpen: _propTypes2.default.bool,
    onDismiss: _propTypes2.default.func,
    closeButtonAriaLabel: _propTypes2.default.string,
    headerText: _propTypes2.default.string
  }),
  formRef: _propTypes2.default.shape({
    current: _propTypes2.default.any
  }),
  tableForm: _propTypes2.default.shape({}),
  conditionalMessageBar: _propTypes2.default.shape({})
}, BulkUpload.defaultProps = {
  conditionalMessageBar: {},
  editPanel: {},
  formRef: _react2.default.createRef(),
  tableForm: {}
}, exports.default = _react2.default.memo(BulkUpload);